<template>
  <div class="add-user-page">
    <form @submit.prevent="showConfirmCreate">
      <div class="row">
        <div class="col">
          <div class="">
            <user-form-fields
              :submitting="submitting"
              :user="user"
              :password.sync="password"
            ></user-form-fields>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <div class="cta-wrapper">
            <b-button type="submit" variant="primary" :disabled="submitting">
              Add User
            </b-button>
          </div>
        </div>
      </div>
    </form>
    <b-modal
      id="confirmAddUser"
      :title="`Add User - ${user.email}`"
      hide-footer
    >
      <p>Create new user: {{ user.email }}?</p>
      <div class="ctas text-right">
        <b-button
          variant="secondary"
          class="mx-3"
          @click="$bvModal.hide('confirmAddUser')"
          :disabled="submitting"
          >Cancel</b-button
        >
        <b-button
          variant="primary"
          class="mx-3"
          @click="submitCreateUser"
          :disabled="submitting"
        >
          <span v-show="submitting">Submitting</span>
          <span v-show="!submitting">Confirm</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { userStore } from '@/stores/userStore'
import UserFormFields from '@/components/UserFormFields'

export default {
  name: 'AddUserPage',
  components: { UserFormFields },
  inject: {
    userStore,
  },
  props: {},
  data: function () {
    return {
      user: {
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
        type: null,
        department: null,
        communicationPreference: 'EMAIL',
        address: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
        },
      },
      password: '',
      submitting: false,
    }
  },
  methods: {
    clearUser() {
      this.user = {
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
        type: null,
        department: null,
        communicationPreference: 'EMAIL',
        address: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
        },
      }
      this.password = ''
    },
    showConfirmCreate() {
      this.$bvModal.show('confirmAddUser')
    },
    submitCreateUser() {
      this.submitting = true
      const data = _.clone(this.user)
      data.password = this.password
      return axios
        .post('/services/v2/users', data)
        .then(response => {
          this.$bvModal.hide('confirmAddUser')
          this.$bvModal.hide('add-user-modal')
          this.clearUser()
          this.$emit('user-created', response.data.user)
          return this.$toasted.success('User Added', {
            duration: 4000,
          })
        })
        .catch(err => {
          return this.$toasted.error(
            'Error creating user: ' + err?.response?.data?.error,
            {
              duration: 4000,
            },
          )
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
  watch: {},
  mounted() {},
}
</script>

<style lang="scss" scoped>
.inputs {
  width: 900px;
  max-width: 90%;
}
</style>


